import { useEffect, useState } from 'react'

/**
 * Holds back a fast-changing value (a controlled input's own state, updated on every
 * keystroke so the field itself stays responsive) and only republishes it `delayMs` after
 * it stops changing -- for feeding into a fetch effect's dependency array, so a half-typed
 * date or plate number doesn't fire a network request per character.
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])
  return debounced
}
